module.exports = __webpack_public_path__ + "static/media/PATS_6-480w.5439379f.webp";